<template>
  <section class="leads-area">
    <div class="leads-area-ellipse position-absolute overflow-hidden w-100" />
    <div class="container">
      <div class="leads-area-card m-auto d-flex align-items-center justify-content-center">
        <div class="lead-area-card-wrap flex-column d-flex justify-content-center align-items-center p-4">
          <h2 class="h1 brand-color">
            View the leads in your area
          </h2>
          <ul class="leads-list mt-3 pl-0">
            <li class="d-flex flex-column flex-md-row text-center align-items-center mb-3">
              <font-awesome-icon class="mr-3 mb-2 mb-md-0" :icon="['fas', 'check']" size="lg" />
              <span class="h3 font-weight-light">No hidden fees, just pay for your leads</span>
            </li>
            <li class="d-flex flex-column flex-md-row align-items-center mb-3">
              <font-awesome-icon class="mr-3 mb-2 mb-md-0" :icon="['fas', 'check']" size="lg" />
              <span class="h3 font-weight-light">Consistent volume - you set the pace, we provide the customers</span>
            </li>
            <li class="d-flex flex-column flex-md-row text-center align-items-center mb-3">
              <font-awesome-icon class="mr-3 mb-2 mb-md-0" :icon="['fas', 'check']" size="lg" />
              <span class="h3 font-weight-light">Trusted lead generation experts for over 10 years</span>
            </li>
            <li class="d-flex flex-column flex-md-row text-center align-items-center">
              <font-awesome-icon class="mr-3 mb-2 mb-md-0" :icon="['fas', 'check']" size="lg" />
              <span class="h3 font-weight-light">Flexible contracts for a scalable partnership</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RegisterLeads",
};
</script>
<style scoped lang="scss">
.leads-area {
  position: relative;
  margin-bottom: 100px;
  margin-top: 80px;

  &-card {
    background: $white;
    box-shadow: 0 0 1.875rem rgba(0,0,0,.16);
    max-width: 650px;
    min-height: 320px;
    border-radius: 48px;

    &-wrap {
      h2 {
        color: $theme-primary;
        margin-bottom: 2rem;
      }
    }
  }

  &-ellipse {
    bottom: -2.1875rem;
    z-index: -2;
    top: 2rem;

    &:before {
      border: 50px solid $body-bg;
      border-radius: 100%;
      content: '\200C';
      height: 200%;
      left: -100%;
      position: absolute;
      width: 300%;
      background: linear-gradient(180deg,$ellipse2-gradient-first 0, $ellipse2-gradient-secondary 100%) no-repeat;
      z-index: -2;
    }
  }
}

.leads {
  &-list {
    li {
      svg {
        margin-top: -.5rem;
        color: $theme-secondary-blue-900;
      }
    }
  }
}

</style>
